import { render, staticRenderFns } from "./Aidex.vue?vue&type=template&id=41c45134&scoped=true&"
import script from "./Aidex.vue?vue&type=script&lang=js&"
export * from "./Aidex.vue?vue&type=script&lang=js&"
import style0 from "./Aidex.vue?vue&type=style&index=0&id=41c45134&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c45134",
  null
  
)

export default component.exports